/* Bored George - small bundle-page DOM helpers.

   Two unrelated jobs live here for one reason: this file and
   bundle-builder.js are the only scripts the section loads, and
   bundle-builder.js is the one that talks to the cart. Keeping edits out of
   that file is deliberate.

   1. Second image on the tiles (mobile half).
      Desktop hover is pure CSS - see bundle-builder.css. Here a swipe across
      a tile moves between the two images, matching the card gallery on the
      normal collection pages. The tile is also the quick-view trigger, so a
      swipe must not be read as a tap: movement past a threshold marks the
      gesture as a swipe and the click that follows is swallowed in the
      capture phase.

   2. The label on the mobile "add a 3rd pair" square.
      bundle-builder.js writes that button's label as one flat string,
      "+ Add a 3rd pair for $111.51". On a phone the control is shrunk to a
      62px square and the words are hidden, so the two pieces worth keeping -
      "3rd pair" and "$111.51" - are lifted into data attributes and printed
      by CSS. See bundle-builder-expand.css for which one is shown. */
(function () {
  'use strict';

  var THRESHOLD = 30;

  function init(grid) {
    if (!grid || grid.dataset.tileGalleryReady === 'true') return;
    grid.dataset.tileGalleryReady = 'true';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    grid.addEventListener('touchstart', function (e) {
      /* Clear first, unconditionally. If this is left set after a swipe, the
         next tap on Add to bundle gets swallowed by the click handler below. */
      swiped = false;
      tracking = false;

      var media = e.target.closest('[data-bgb-media]');
      if (!media || media.dataset.hasAlt !== 'true') return;

      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    grid.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      /* Horizontal only - a vertical drag is the shopper scrolling the page. */
      if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) swiped = true;
    }, { passive: true });

    grid.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      if (!swiped) return;
      var media = e.target.closest('[data-bgb-media]');
      if (!media) return;
      media.dataset.alt = media.dataset.alt === 'true' ? 'false' : 'true';
    });

    grid.addEventListener('click', function (e) {
      if (!swiped) return;
      swiped = false;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  /* ---------- contents of the third-pair square ---------- */

  /* "+ Add a 3rd pair for $111.51" -> "3rd pair".
     The first word starting with a digit is the ordinal, whatever the tier
     numbers become. Custom wording with no ordinal in it returns nothing, and
     the square is then just a plus - which is the right thing to show rather
     than a guess. */
  function shortLabel(text) {
    var words = text.split(' ');
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      var c = w.charCodeAt(0);
      if (w.length >= 3 && c >= 48 && c <= 57) return w + ' pair';
    }
    return '';
  }

  function syncExpand(btn) {
    var text = (btn.textContent || '').trim();
    if (!text) return;

    var at = text.lastIndexOf('$');
    var price = at === -1 ? '' : text.slice(at).trim();
    if (btn.dataset.bgbStepPrice !== price) btn.dataset.bgbStepPrice = price;

    var label = shortLabel(text);
    if (btn.dataset.bgbStepLabel !== label) btn.dataset.bgbStepLabel = label;
  }

  function watchExpand(root) {
    var btn = root.querySelector('[data-bgb-expand]');
    if (!btn || btn.dataset.bgbExpandWatched === 'true') return;
    btn.dataset.bgbExpandWatched = 'true';

    syncExpand(btn);

    if (typeof MutationObserver !== 'function') return;
    /* childList and characterData only. Watching attributes would see our own
       writes and loop. */
    var mo = new MutationObserver(function () { syncExpand(btn); });
    mo.observe(btn, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('[data-bgb-grid]').forEach(init);
    document.querySelectorAll('[data-bgb-root]').forEach(watchExpand);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();